import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { api } from "../lib/api";

export default function CategoryPage() {
    const { name } = useParams();
    const nav = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const pretty = decodeURIComponent(name || "").replace(/-/g, " ");

    useEffect(() => {
        setLoading(true);
        api.get("/articles", { params: { category: pretty, limit: 50 } })
            .then((r) => setItems(r.data))
            .finally(() => setLoading(false));
    }, [pretty]);

    return (
        <div className="bg-black text-white min-h-screen">
            <SEO
                title={`${pretty} stories`}
                description={`The latest ${pretty.toLowerCase()} stories on MyStreetzMag — Afrobeats, Naija street culture and more.`}
                keywords={[pretty, "Afrobeats", "MyStreetzMag"]}
            />
            <Header />
            <main className="max-w-[1400px] mx-auto px-4 md:px-8 py-12">
                <button onClick={() => nav("/")} data-testid="category-back" className="inline-flex items-center gap-2 overline text-streetz-muted hover:text-streetz-red">
                    <ArrowLeft className="w-4 h-4" /> BACK
                </button>
                <h1 className="font-display uppercase text-5xl md:text-7xl mt-4 leading-none">{pretty}</h1>
                <p className="text-streetz-muted mt-2">{items.length} stor{items.length === 1 ? "y" : "ies"}</p>

                {loading ? (
                    <p className="text-streetz-muted mt-12">Loading…</p>
                ) : items.length === 0 ? (
                    <p className="text-streetz-muted mt-12">Nothing in this category yet.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10" data-testid="category-grid">
                        {items.map((a) => (
                            <Link
                                key={a.id}
                                to={`/article/${a.slug}`}
                                data-testid={`category-article-${a.slug}`}
                                className="bg-streetz-paper border border-streetz-line hover:border-streetz-red transition-colors group flex flex-col"
                            >
                                {a.image_url && (
                                    <img src={a.image_url} alt={a.title} className="aspect-video object-cover" />
                                )}
                                <div className="p-5 flex-1 flex flex-col">
                                    <span className="overline text-streetz-red">{a.category}</span>
                                    <h3 className="font-display uppercase text-2xl mt-2 leading-tight group-hover:text-streetz-yellow">{a.title}</h3>
                                    <p className="text-sm text-streetz-muted mt-2 line-clamp-2">{a.excerpt}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </main>
            <Footer />
        </div>
    );
}
